import createReactComponent from '../createReactComponent';
export default createReactComponent('arrow-up-left', 'ArrowUpLeft', [["path",{"d":"m17.5 17.5-11-11m0 9v-9h9","key":"svg-0"}]]);